<template>
    <div class="user_options-container">
        <span v-if="!isLogged" class="text">{{translate("log_in")}}</span>
        <span v-if="isLogged" class="text">{{translate("account")}}</span>
        <span class="icon-bottom_arrow"/>
        <div class="wrapper">
            <div v-if="!isLogged" class="links-container">
                <router-link to="/login">
                    <span class="icon-person_ver_solid"/>
                    <span class="text">{{translate("log_in")}}</span>
                </router-link>
                <router-link to="/register">
                    <span class="icon-plus"/>
                    <span class="text">{{translate("registration")}}</span>
                </router-link>
            </div>
            <div v-else class="links-container">
                <a @click.prevent="offers">
                    <span class="icon-doc"/>
                    <span class="text">{{translate("offers")}}</span>
                </a>
                <a @click.prevent="logout">
                    <span class="icon-person_ver_solid"/>
                    <span class="text">{{translate("log_out")}}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserOptions",
        methods: {

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            offers() {
                this.$store.state.offerSearchQuery = '';
                this.$router.push('/offers').catch(err => {
                });
            },

            resetUserData() {
                this.$store.state.isUserLogged = false;
                this.$store.state.isUserLogged = '';
                this.$store.state.userRole = '';
                this.$store.state.userId = '';
                this.$store.state.userCompany = '';
                localStorage.userApplicationToken = '';
                localStorage.userEmail = '';
                localStorage.userDiscountValue = 0;
                localStorage.userRole = '';
                localStorage.userId = '';
                localStorage.userCompany = '';
            },

            logout: function () {
                this.resetUserData();
                //OFFER SUPPORT
                this.$store.state.productCard.custom.basic.values.prepared_by.value = '-';
                this.$router.push('/login');
                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('notification_success'), this.translate('app_logout_success'));

                this.$store.state.lastPathParameters = {
                    selectedFirstStepElement: null,
                    selectedSecondStepElement: null,
                    selectedThirdStepElement: null
                };

                //UPDATE USER SPECIFIED CONTENT
                this.$apiController.getVariablesFullList()
                    .then((res) => {
                        if (res.status === 'success')
                            this.$store.state.appVariables = res.data;
                    });
                this.$apiController.getPricesList()
                    .then((res) => {
                        if (res.status === 'success')
                            this.$store.state.pricesList = res.data;
                    });
            }
        },
        computed: {
            isLogged() {
                return this.$store.getters.getIfUserLogged;
            }
        },
        created() {
            if (localStorage.userApplicationToken !== undefined && localStorage.userApplicationToken !== '') {

                let form = new FormData();
                form.append('token', localStorage.userApplicationToken);
                this.$apiController.checkUserToken(form)
                    .then((response) => {
                        if (response.status === 'success') {
                            if (response.data.token === true) {
                                this.$store.state.isUserLogged = true;
                                this.$store.state.userEmail = localStorage.userEmail;
                                if(response.data.role !== localStorage.userRole) {
                                    console.log('role updated');
                                }
                                this.$store.state.discount.userDiscountValue = response.data.discount_value;
                                this.$store.state.userRole = response.data.role;
                                this.$store.state.userId = localStorage.userId;
                                this.$store.state.userCompany = localStorage.userCompany;
                            } else {
                                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('notification_success'), this.translate('app_logout_success'));
                                this.resetUserData();
                            }
                        } else {
                            this.resetUserData();
                        }
                    });

            } else {
                this.resetUserData();
            }

        }
    }
</script>